import ecomdash from "../Assets/projectImages/ecomdash.png"
import flipkart from "../Assets/projectImages/flipkart.png"
import spotify from "../Assets/projectImages/spotify.png"
import quiz from "../Assets/projectImages/quiz.png"

export const projects = [
    {
        id: 1,
        name: "Dashboard Application",
        subtitle: "API May Take Few Minutes To Load",
        responsive: "Y",
        image: ecomdash,
        github: "https://github.com/Fawwaz-GitHub/ECOMDASH-FULLSTACK",
        host: "https://ecomdash.onrender.com/",
    },
    {
        id: 2,
        name: "Flipkart Clone",
        subtitle: "API May Take Few Minutes To Load",
        responsive: "Y",
        image: flipkart,
        github: "https://github.com/Fawwaz-GitHub/FlipKart-Clone",
        host: "https://flippedcart.onrender.com/",
    },
    {
        id: 3,
        name: "Spotify Clone",
        subtitle: "Spotify Subscription Needed To Play",
        responsive: "N",
        image: spotify,
        github: "https://github.com/Fawwaz-GitHub/SpotifyClone",
        host: "https://cloned-spotify.netlify.app/",
    },
    {
        id: 4,
        name: "Football Quiz",
        subtitle: "Answer The Questions Within Time",
        responsive: "Y",
        image: quiz,
        github: "https://github.com/Fawwaz-GitHub/FootballQuiz",
        host: "https://fawwaz-github.github.io/FootballQuiz/",
    },
]